import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Error, LoadingSpinner } from '../../components'
import getAuth0 from '../../utils/auth0'
import handleCallback from '../../utils/auth0/handleCallback'
import { newRelicTriggerSuccessEvent, newRelicTriggerErrorEvent } from '../../utils/newrelic'
import { triggerErrorEvent, triggerEvent } from '../../utils/analytics'

export default function BrowseCallback(): JSX.Element {
  const [searchParams] = useSearchParams()
  const [error, setError] = useState<{ code: string } | null>(null)

  useEffect(() => {
    ;(async () => {
      try {
        triggerEvent('browseCallbackPageLoad')
        const auth0 = getAuth0()
        const continueTo = searchParams.get('continueTo') || window.location.origin
        await handleCallback()
        await auth0.atg.extendSession()
        const token = await auth0.getIdTokenClaims()
        newRelicTriggerSuccessEvent('browse-callback')
        const url =
          token['https://www.johnlewis.com/auth/skipOptionalEV'] === 'true'
            ? `${window.auth.ACCOUNT_URL}/sign-in-details/edit-email`
            : token['https://www.johnlewis.com/auth/isRegistration'] === 'true'
              ? `${window.auth.ACCOUNT_URL}/account-created?continueUrl=${continueTo}&newSignUpFlow=true`
              : continueTo
        window.location.replace(url)
      } catch (error: any) {
        console.error(error)
        newRelicTriggerErrorEvent('browse-callback', error)
        triggerErrorEvent(error.message)
        setError({ code: 'browse.callback.error' })
      }
    })()
  }, [])

  return <div data-testid="browse-callback">{error ? <Error /> : <LoadingSpinner />}</div>
}
